import React from "react";
import Routes from "../routes/index";

export default () => <>{Routes}</>;